import React from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Divider } from 'antd'
import OneDrivePage from '../../../../../components/Onedrive/OneDrive'

const BudgetOneDrive = () => {
  const { t } = useTranslation()
  return (
    <>
      <OneDrivePage type="budget" dokumentationPath="/budgeting/import/onedrive" />
      <Divider />
      <Alert description={t('budgetingImportPage:info-text')} />
    </>
  )
}

export default BudgetOneDrive
